import React, {FC, memo} from 'react'
import {Box, Button, Modal, Stack, Typography} from "@mui/material";
import Image from "next/image";
import {ApiCallsLoadingModal} from "@/src/components/pages/StepPage/components/apiCalls/Modals/Loading";

interface ConfirmModalProps {
    isOpen: boolean;
    email: string;
    isLoading?: boolean;
    onAccept: () => void;
    onCancel: () => void;
}

const ConfirmModal: FC<ConfirmModalProps> = ({ isOpen, email, isLoading, onAccept, onCancel}) => {

    return (
        <Modal open={isOpen} onClose={onCancel}>
            {
                isLoading
                ? <ApiCallsLoadingModal title={"Зачекайте, будь ласка"} description={"Ми синхронізуємо дані"} />
                : <Stack className="flex w-full max-w-[524px] flex-col items-center gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal">
                    <Box>
                        <Image
                            width={80}
                            height={80}
                            src={"/images/confirm-modal.svg"}
                            alt="Продовження покупки"
                        />
                    </Box>
                    <Typography
                        component={"h4"}
                        className="text-lg font-semibold text-dark-gray"
                    >
                        {"Продовжити покупки?"}
                    </Typography>
                    <Typography
                        component={"h4"}
                        className="text-[15px] font-normal text-dark-gray text-center"
                    >
                        {"Для продовження покупки страхового полісу необхідно підтвердити особу. На вашу електронну адресу "}
                        <b>{email}</b>
                        {" буде надіслано код."}
                    </Typography>
                    <Stack className="flex-center-row w-full gap-3">
                        <Button onClick={onCancel} variant="outlined" className="w-full" size='large'>
                            {"Скасувати"}
                        </Button>
                        <Button onClick={onAccept} variant="contained" className="w-full" size='large'>
                            {"Надіслати код"}
                        </Button>
                    </Stack>
                </Stack>
            }
        </Modal>
    )
}

export default memo(ConfirmModal)
